import script from "./NoticeItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeItemModal.vue?vue&type=script&setup=true&lang=js"

import "./NoticeItemModal.vue?vue&type=style&index=0&id=0402f502&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0402f502"]])

export default __exports__